import { render, staticRenderFns } from "./ProjectSummaryDetails.vue?vue&type=template&id=ae668fb4"
import script from "./ProjectSummaryDetails.vue?vue&type=script&lang=js"
export * from "./ProjectSummaryDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports